export const ds_NewsIntegrationListingBlock_Entry = `
    fragment ds_NewsIntegrationListingBlock_Entry on ds_NewsIntegrationListingBlock_Entry {
        id
        canonicalUid

        newsListing_TopSpacing
        newsListing_HeadingAndTextAlignment
        newsListing_FullWidthBackground
        newsListing_ContainerWidth
        newsListing_ColorTheme
        newsListing_ColorPalette

        newsListing_NumberOfColumnsDesktop
        newsListing_FeaturedArticlesPalette
        newsListing_FeaturedArticles
        newsListing_FeaturedArticleImagePosition

        newsListing_Heading
        newsListing_BodyText
        newsListing_Integration {
           integration
           category
        } 

    }
`